import React from 'react';
import { Video, Music, Mic, Image, Plus } from 'lucide-react';

const HomeScreen = ({ onSelectTemplate, onSelectCategory }) => {
  // 人気のコンテンツテンプレート
  const templates = [
    { 
      id: 1, 
      title: "縦型ショート動画作成", 
      description: "30秒の縦型動画コンテンツを簡単に作成",
      popularity: 5487,
      gradientColors: "from-red-500 to-purple-600",
      icon: <Video size={24} />
    },
    { 
      id: 2, 
      title: "音声合成コンテンツ", 
      description: "AIボイスでナレーションやセリフを作成",
      popularity: 4321,
      gradientColors: "from-blue-500 to-cyan-600",
      icon: <Mic size={24} />
    },
    { 
      id: 3, 
      title: "TikTokバズダンス生成", 
      description: "トレンドのダンスモーションを自動生成",
      popularity: 3856,
      gradientColors: "from-pink-500 to-red-600",
      icon: <Video size={24} />
    },
    { 
      id: 4, 
      title: "音楽PV生成", 
      description: "楽曲に合わせた映像を自動生成",
      popularity: 2710,
      gradientColors: "from-purple-500 to-indigo-600",
      icon: <Music size={24} />
    }
  ];
  
  // 人気の度合いを表示する関数
  const formatPopularity = (num) => {
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'k';
    }
    return num.toString();
  };
  
  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">人気のテンプレート</h2>
        <button className="text-blue-500 text-sm font-medium">すべて見る</button>
      </div>
      
      <div className="space-y-4">
        {templates.map((template, index) => (
          <div key={template.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="flex">
              <div className="w-24 h-24 relative overflow-hidden">
                <div className={`absolute inset-0 bg-gradient-to-br ${template.gradientColors}`}>
                </div>
                <div className="absolute inset-0 flex items-center justify-center text-white">
                  {template.icon}
                </div>
                <div className="absolute top-0 left-0 bg-black bg-opacity-60 px-2 py-1 text-xs text-white font-semibold">
                  #{index + 1}
                </div>
              </div>
              
              <div className="flex-1 p-3">
                <div className="flex justify-between items-start">
                  <h3 className="font-medium text-base">{template.title}</h3>
                  <div className="flex items-center text-gray-500 text-xs ml-2">
                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                    <span>{formatPopularity(template.popularity)}</span>
                  </div>
                </div>
                <p className="text-xs text-gray-500 mt-1">{template.description}</p>
                <button 
                  onClick={() => onSelectTemplate(template.id)}
                  className="mt-2 bg-blue-50 text-blue-600 px-3 py-1 rounded-full text-xs font-medium hover:bg-blue-100 transition-colors"
                >
                  使ってみる
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-6">
        <h2 className="text-lg font-semibold mb-4">おすすめカテゴリ</h2>
        <div className="grid grid-cols-2 gap-3">
          {[
            {id: "video", name: "ショート動画", color: "bg-red-500", icon: <Video size={16} />},
            {id: "voice", name: "音声ナレーション", color: "bg-blue-500", icon: <Mic size={16} />},
            {id: "music", name: "BGM作成", color: "bg-green-500", icon: <Music size={16} />},
            {id: "image", name: "画像生成", color: "bg-purple-500", icon: <Image size={16} />}
          ].map((category) => (
            <div 
              key={category.id} 
              className="bg-white rounded-lg shadow-md p-3 flex items-center cursor-pointer hover:bg-gray-50"
              onClick={() => onSelectCategory(category.id)}
            >
              <div className={`${category.color} w-8 h-8 rounded-full flex items-center justify-center text-white mr-3`}>
                {category.icon}
              </div>
              <span className="text-sm font-medium">{category.name}</span>
            </div>
          ))}
        </div>
      </div>
      
      <div className="mt-6 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg shadow-lg p-4 text-white">
        <div className="flex justify-between items-center">
          <div>
            <h3 className="font-bold text-lg">新規作成</h3>
            <p className="text-xs text-blue-100 mt-1">ゼロからコンテンツを作成</p>
          </div>
          <div className="bg-white bg-opacity-20 rounded-full p-3">
            <Plus size={20} className="text-white" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;